import { ParticipantList } from "Components/ParticipantList";

const ParticipantPage = () => <ParticipantList />;

export default ParticipantPage;
